import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

/**
 * Same gate as Admin Control Center: only users with isAllowedAdmin (super admin) from the profile API.
 * Use inside AuthGuard so the user is already authenticated.
 *
 * To make marketing public later (e.g. like pricing), remove this wrapper or gate on
 * REACT_APP_MARKETING_PUBLIC — see comment on the /marketing/clinical route in App.tsx.
 */
const RequireSuperAdmin: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const profile = useSelector((s: RootState) => s.user.profile);
  const isAllowedAdmin = useSelector((s: RootState) => s.user.isAllowedAdmin);

  useEffect(() => {
    if (!profile) return;
    if (isAllowedAdmin === false) {
      navigate('/', { replace: true });
    }
  }, [profile, isAllowedAdmin, navigate]);

  if (!profile) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        Loading…
      </div>
    );
  }
  if (isAllowedAdmin === null) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        Loading…
      </div>
    );
  }
  if (isAllowedAdmin !== true) {
    return null;
  }

  return <>{children}</>;
};

export default RequireSuperAdmin;
